import React from 'react';

import utils      from '../../../../utils';
import Context    from '../../../../context';
import Components from '../Create/Components';

import { CustomModal            } from '../../../../components';
import { ICreateAndUpdateSchool } from '../../../../types/school.interface';

import './index.sass';

const Update: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal, selectedSchool, updateFunction } = React.useContext(Context.SchoolScreen);
  const [step, setStep] = React.useState<number>(1);
  const [formData, setFormData] = React.useState<ICreateAndUpdateSchool>({});

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onBack(event: ICreateAndUpdateSchool) {
    setFormData({ ...formData, ...event });
    setStep(step - 1);
  }

  function onNext(event: ICreateAndUpdateSchool) {
    setFormData((prevFormData: ICreateAndUpdateSchool) => ({...prevFormData, ...event}));
    setStep(step + 1);
  }

  function onSubmit(event: ICreateAndUpdateSchool) {
    updateFunction!({ ...formData, ...event });
  }

  function RenderUpdateSchool() {
    switch (step) {
      case 1 : return (<Components.SchoolInformation defaultValues={formData} onSubmit={onNext}/>);
      case 2 : return (<Components.TimingInformation defaultValues={formData} onSubmit={onSubmit} onBack={onBack}/>);
      default :return null;
    }
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect(() => {
    setFormData({
      ...selectedSchool,
      grade: utils.convertSchoolGrade.mangoToHtml(selectedSchool?.grade),
    });
  }, [selectedSchool]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="school-update-modal-container">
      <CustomModal onClose={() => setShowModal("NONE")} open={showModal === "UPDATE"}>
        <RenderUpdateSchool />
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default Update;
